import { render, staticRenderFns } from "./loading-page.vue?vue&type=template&id=e7548a06&scoped=true"
import script from "./loading-page.vue?vue&type=script&lang=js"
export * from "./loading-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7548a06",
  null
  
)

export default component.exports